<template>
  <div id="app">
    <headerNav v-if="$route.meta.header"/>
    <router-view v-if="isRouterAlive"/>
<!--    <bottomNav v-if="$route.meta.bottom"/>-->
  </div>
</template>

<script>
import header from '@/card/views/Header'
import bottom from '@/card/views/Bottom'

export default {
  name: 'App',
  components: {
    headerNav: header,
    bottomNav: bottom
  },
  provide () {
    return {
      reload: this.reload
    }
  },
  data () {
    return {
      isRouterAlive: true
    }
  },
  methods: {
    async checkVersion () {
      try {
        // 1. 获取服务器版本（加时间戳防缓存）
        const response = await fetch(`/wechat/ufi/static/version.json?t=${Date.now()}`, {
          cache: 'no-store',
          headers: { 'Cache-Control': 'no-cache' }
        })
        if (!response.ok) return
        const data = await response.json()
        const serverVersion = data.version
        const localVersion = this.getCookieValue('h5_version')
        console.log('Server:', serverVersion, 'Local:', localVersion)
        // 2. 逻辑判断
        if (serverVersion) {
          // 场景：本地有旧版本，且与服务器不一致 -> 强制更新并刷新
          if (localVersion && localVersion !== serverVersion) {
            this.setCookie('h5_version', serverVersion, 24)
            console.log('检测到旧版本，正在强刷页面...')
            // 使用时间戳确保 HTML 重新请求
            const newUrl = new URL(window.location.href)
            newUrl.searchParams.set('update_v', serverVersion)
            window.location.replace(newUrl.toString())
            return
          }
          // 场景：本地没有版本记录（新用户） -> 仅记录，不刷新
          if (!localVersion) {
            this.setCookie('h5_version', serverVersion, 24)
            console.log('首次访问，记录版本号:', serverVersion)
          }
        }
      } catch (error) {
        console.error('版本检测失败:', error)
      }
    },
    setCookie (name, value, hours) {
      const exp = new Date()
      exp.setTime(exp.getTime() + hours * 60 * 60 * 1000)
      document.cookie = `${encodeURIComponent(name)}=${encodeURIComponent(value)};expires=${exp.toUTCString()};path=/`
    },
    getCookieValue (name) {
      const nameEQ = `${encodeURIComponent(name)}=`
      const cookies = document.cookie.split(';')
      for (let cookie of cookies) {
        cookie = cookie.trim()
        if (cookie.startsWith(nameEQ)) {
          return decodeURIComponent(cookie.substring(nameEQ.length))
        }
      }
      return null
    },
    reload () {
      this.isRouterAlive = false
      this.$nextTick(function () {
        this.isRouterAlive = true
      })
    }
  }
}
window.onload = function () {
  document.addEventListener('touchstart', function (event) {
    if (event.touches.length > 1) {
      event.preventDefault()
    }
  })
  document.addEventListener('gesturestart', function (event) {
    event.preventDefault()
  })
}
</script>

<style>
#app {
  /*font-family: 'Avenir', Helvetica, Arial, sans-serif;*/
  /*-webkit-font-smoothing: antialiased;*/
  /*-moz-osx-font-smoothing: grayscale;*/
  /*text-align: center;*/
}
body {
  background: #f6f6f6;
}
</style>



// WEBPACK FOOTER //
// src/App.vue